import React from 'react';
import './mask_icon.ui.scss';

interface IMaskIcon {
  src: string;
  size?: number;
}

// A single-colour SVG asset drawn through a CSS mask, so it takes the surrounding text colour (currentColor).
const MaskIcon = (props: IMaskIcon) => {
  const { src, size = 18 } = props;

  return (
    <span
      className="mask_icon"
      aria-hidden="true"
      style={{ width: size, height: size, WebkitMaskImage: `url(${src})`, maskImage: `url(${src})` }}
    />
  );
};

export default MaskIcon;
